import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";

import * as userApi from "../../api/userApi/userApi";
import {EQUser, initializeUser} from "../../models/serverModels/EQUser";
import OfficerForm from "./OfficerForm";
import {yupResolver} from "@hookform/resolvers/yup";
import {userSchema} from "../../validation/userSchema";

const CreateOfficer = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EQUser>,
    Params.Create<EQUser>
  >({
    api: userApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Officer`);
        queryClient.invalidateQueries("OfficerList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EQUser>({
    defaultValues: initializeUser(),
    resolver: yupResolver(userSchema),
  });

  const onSubmit: SubmitHandler<EQUser> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeUser(), ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="담당자 추가" />
      {isLoading && <MWProgress />}

      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <OfficerForm idDisabled={false} />
          <ConfirmButtonGroup link={`/Officer`} cancelText="취소" confirmText="추가" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateOfficer;
